/** @see https://docs.iheartjane.com/jane-docs/implementing-roots/embedding-checkout */
export const getCartScriptElement = () =>
  document.querySelector<HTMLIFrameElement>('iframe#jane-menu');
